export default {
  SET_CURRENT_ROW: 'SET_CURRENT_ROW',
  SET_TAGS_COUNTER: 'SET_TAGS_COUNTER',
  SET_HAS_TICKETS: 'SET_HAS_TICKET',
}
